import { useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';

import Layout from '#layout/index';
import {
 Button, SelectField, TextField, Typography 
} from '#atoms/index';
import { CircleStrongSpinner, Toast } from '#components/index';
import { useUserGeolocalization } from '#hooks/index';
import { regexEmail } from '#helpers/regex';
import { times } from '#helpers/formsUtils';
import { postFreeClass } from '#api/enrollment';

const PurchaseFlow = () => {
  const {
    register,
    handleSubmit,
    errors,
    formState: {}
  } = useForm({ mode: 'onChange' });
  const router = useRouter();
  const [phone, setPhone] = useState();
  const [_country, setCountry] = useState();
  const { data: geolocalizationData } = useUserGeolocalization();
  const [loader, setLoader] = useState(false);

  const onSubmit = async data => {
    setLoader(true);
    const params = {
      fields: [
        { name: 'firstname', value: data.guardian_first_name },
        { name: 'lastname', value: data.guardian_last_name },
        { name: 'phone', value: phone },
        { name: 'rango_de_edad_clasesprueba', value: data.guardian_student_age },
        { name: 'email', value: data.guardian_email },
        { name: 'name_student_test_class', value: data.guardian_student_name },
        { name: 'cp_form_source', value: document.referrer }
      ]
    };

    const queryParams = new URLSearchParams(window?.location.search);
    const query = {
      first_name: data?.guardian_first_name,
      last_name: data?.guardian_last_name,
      email: data?.guardian_email,
      phone: phone,
      student_name: data?.guardian_student_name,
      type: data?.guardian_student_age,
      utm_source: queryParams.get('utm_source') || '',
      utm_medium: queryParams.get('utm_medium') || ''
    };

    // Go to
    const pathname = '/clase-gratis/gracias';

    try {
      const response = await postFreeClass(params);
      if (response) {
        router.push({
          pathname
          // query,
        });
      }
    } catch {
      router.push({
        pathname
        // query,
      });
    }
  };

  const handleOnChange = (value, country) => {
    setPhone(`+${value}`);
    setCountry(country);
  };

  return (
    <>
      <Head>
        <title>Inscripción | Crack The Code</title>
        <meta name="inscripción" content="Inscribirse a un curso" />
        <meta name="robots" content="noindex,follow" />
      </Head>
      <Layout mainType="full_variant">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center'
          }}
        >
          <div className="free-class flex justify-center items-center">
            <div className="w-60 mr-5">
              <Typography variant="h2">
                ¡Agenda una <span className="orange">clase gratis!</span>
              </Typography>
              <form className="free-class-form" onSubmit={handleSubmit(onSubmit)}>
                <Typography variant="h4">Datos del padre/tutor:</Typography>
                <div className="mt-2 grid_2x2 mb-5">
                  <div className="field_row">
                    <TextField
                      id="guardian_first_name"
                      name="guardian_first_name"
                      variant="purchase-flow"
                      placeholder="Nombre"
                      type="text"
                      register={register({ required: 'Olvidaste tu nombre' })}
                      error={!!errors.guardian_first_name}
                    />
                    {errors.guardian_first_name && (
                      <Toast message={errors.guardian_first_name.message} mtop=".5rem" />
                    )}
                  </div>
                  <div className="field_row">
                    <TextField
                      id="guardian_last_name"
                      name="guardian_last_name"
                      variant="purchase-flow"
                      placeholder="Apellido"
                      type="text"
                      register={register({ required: 'Olvidaste tu apellido' })}
                      error={!!errors.guardian_last_name}
                    />
                    {errors.guardian_last_name && (
                      <Toast message={errors.guardian_last_name.message} mtop=".5rem" />
                    )}
                  </div>
                  <div className="field_row">
                    <TextField
                      id="guardian_email"
                      name="guardian_email"
                      type="guardian_email"
                      variant="purchase-flow"
                      placeholder="Correo electrónico"
                      register={register({
                        required: 'Verifica tu correo electrónico',
                        pattern: {
                          value: regexEmail,
                          message: 'Esto no es un email, intenta con uno válido'
                        }
                      })}
                      error={!!errors.guardian_email}
                    />
                    {errors.guardian_email && (
                      <Toast message={errors.guardian_email.message} mtop=".5rem" />
                    )}
                  </div>
                  <div className="field_row">
                    {geolocalizationData && (
                      <div className="phone_input-Wrapper">
                        <PhoneInput
                          inputProps={{
                            name: 'phone_number',
                            required: true
                          }}
                          inputClass={'custom-phone-input'}
                          country={geolocalizationData.countryCode.toLowerCase()}
                          value={phone}
                          onChange={handleOnChange}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <Typography variant="h4" className="mt-5">
                  Datos del estudiante:
                </Typography>
                <div className="grid_2x2 mb-5 mt-2">
                  <div className="field_row">
                    <TextField
                      id="guardian_student_name"
                      name="guardian_student_name"
                      variant="purchase-flow"
                      placeholder="Nombre de estudiante"
                      type="text"
                      register={register({required: 'Olvidaste el nombre del estudiante'})}
                      error={!!errors.guardian_student_name}
                    />
                    {errors.guardian_student_name && (
                      <Toast
                        message={errors.guardian_student_name.message}
                        mtop=".5rem"
                      />
                    )}
                  </div>
                  <div className="field_row">
                    <SelectField
                      id="guardian_student_age"
                      name="guardian_student_age"
                      variant="purchase-flow"
                      placeholder="Edad del estudiante"
                      options={times}
                      register={register({ required: 'Elige edad del estudiante' })}
                      error={!!errors.guardian_student_age}
                    />
                    {errors.guardian_student_age && (
                      <Toast message={errors.guardian_student_age.message} mtop=".5rem" />
                    )}
                  </div>
                </div>

                <span className="free-class-button flex justify-end">
                  <Button type="submit">
                    {!loader ? 'Registrarse' : <CircleStrongSpinner />}
                  </Button>
                </span>
              </form>
            </div>

            <div className="free-class-image w-40">
              <img src="/free-class/free-class.webp" />
            </div>
          </div>

          <div className="free-class-footer free-class bg-course bg-gray go-to-login mb-6 text-center">
            <div className="mx-500">
              <Typography variant="h4">
                Agenda una clase de prueba y tu hij@ conocerá lo{' '}
                <strong>divertido que es aprender programación</strong> y las opciones que
                tiene para hacerlo.
              </Typography>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default PurchaseFlow;
